export enum STOCK_CONFIG {
  NONE = 0,
  SHOW_NOT_LIMIT = 1,
  SHOW_DISABLED = 2,
  DONT_SHOW = 3,
}

export type StockConfigType = keyof typeof STOCK_CONFIG
